/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_budget_no_data = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No fantasy data available for this race`)
};

const es_f1_budget_no_data = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay datos fantasy disponibles para esta carrera`)
};

const de_f1_budget_no_data = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Fantasy-Daten für dieses Rennen verfügbar`)
};

const nl_f1_budget_no_data = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen fantasy-gegevens beschikbaar voor deze race`)
};

const fr_f1_budget_no_data = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune donnée fantasy disponible pour cette course`)
};

const it_f1_budget_no_data = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun dato fantasy disponibile per questa gara`)
};

const pt_br2_f1_budget_no_data = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum dado fantasy disponível para esta corrida`)
};

const pt_f1_budget_no_data = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum dado fantasy disponível para esta corrida`)
};

const ja_f1_budget_no_data = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このレースのファンタジーデータがありません`)
};

const zh_f1_budget_no_data = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本场比赛无梦幻数据`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_budget_no_data = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_budget_no_data(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_budget_no_data", locale)
	if (locale === "en") return en_f1_budget_no_data(inputs)
	if (locale === "es") return es_f1_budget_no_data(inputs)
	if (locale === "de") return de_f1_budget_no_data(inputs)
	if (locale === "nl") return nl_f1_budget_no_data(inputs)
	if (locale === "fr") return fr_f1_budget_no_data(inputs)
	if (locale === "it") return it_f1_budget_no_data(inputs)
	if (locale === "pt-BR") return pt_br2_f1_budget_no_data(inputs)
	if (locale === "pt") return pt_f1_budget_no_data(inputs)
	if (locale === "ja") return ja_f1_budget_no_data(inputs)
	return zh_f1_budget_no_data(inputs)
};